import { cleanPID, fullRecipeType, getBusinessForDate, STORAGE_URL } from "../../../helpers/utils"

import { AlignmentType, BorderStyle, convertMillimetersToTwip, Document, Footer, Header, HeadingLevel, ImageRun, Packer, PageOrientation, Paragraph, Table, TableCell, TableLayoutType, TableRow, TextRun, VerticalAlign, WidthType } from "docx";
import { saveAs } from "file-saver";
import { getAllergensForRecipe } from "../specCardsHelpers";
import { buildIngredientList } from "./Label";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBook } from "@fortawesome/free-solid-svg-icons";


const businessData = getBusinessForDate()


const nutMargins = {
      top: 80,
      bottom: 80,
      left: 80,
      right: 80,
    };

const margins = {
      top: 80,
      bottom: 80,
      left: 80,
      right: 80,
    };

export const parseBoldRuns = (input) => {
  const regex = /\[\[(.*?)\]\]/g;

  const runs = [];
  let lastIndex = 0;

  let match;

  

  while ((match = regex.exec(input)) !== null) {
    // normal text before bold
    if (match.index > lastIndex) {
      runs.push(
        new TextRun({
          text: input.slice(lastIndex, match.index),
          bold: false,
        })
      );
    }

    // bold text
    runs.push(
      new TextRun({
        text: match[1],
        bold: true,
      })
    );

    lastIndex = regex.lastIndex;
  }

  // remaining normal text
  if (lastIndex < input.length) {
    runs.push(
      new TextRun({
        text: input.slice(lastIndex),
        bold: false,
      })
    );
  }

  return runs;
}

export const LookBook = ({recipes, allRecipes, recipe}) => {

  if (!recipe) return ''

  const allergens = getAllergensForRecipe(recipes, recipe)
  const allergenList = allergens.filter(a => a !== '!').join(', ')

  const PID = cleanPID(recipe.pid, recipe.type)

  const handleDownload = async () => {

    // load image
    const imageUrl = `${STORAGE_URL}/object/public/recipes/${PID}/0.png`
    console.log(imageUrl)
    const imageResponse = await fetch(imageUrl);
    const imageBuffer = await imageResponse.arrayBuffer();


    const formattedIngredients = parseBoldRuns(buildIngredientList(allRecipes, '[[', ']]', ' '))


    const portionWeight = Math.floor(10 * recipe.net_weight / (recipe.portions || 1)) / 10
    const portionMultiplier = portionWeight / 100

    const nutrition = new Table({
      layout: TableLayoutType.FIXED,
      rows: [
          new TableRow({
            children: [
              new TableCell({
                width: {
                    size: convertMillimetersToTwip(40),
                    type: WidthType.DXA,
                },
                margins: nutMargins,
                children: [new Paragraph({
                  children: [
                    new TextRun({
                      text: "Nutrition",
                      bold: false,
                    }),
                  ]
                })],
              }),
              new TableCell({
                width: {
                    size: convertMillimetersToTwip(30),
                    type: WidthType.DXA,
                },
                margins: nutMargins,
                children: [new Paragraph({
                  alignment: AlignmentType.RIGHT,
                  children: [
                    new TextRun({
                      text: `Per 100g`,
                      bold: false,
                    }),
                  ]
                })],
              }),
              new TableCell({
                width: {
                    size: convertMillimetersToTwip(30),
                    type: WidthType.DXA,
                },
                margins: nutMargins,
                children: [new Paragraph({
                  alignment: AlignmentType.RIGHT,
                  children: [
                    new TextRun({
                      text: `Per ${portionWeight}g`,
                      bold: false,
                    }),
                  ]
                })],
              }),
            ],
          }),
          new TableRow({
            children: [
              new TableCell({
                margins: nutMargins,
                children: [new Paragraph({
                  children: [
                    new TextRun({
                      text: "Energy kJ",
                      bold: true,
                    }),
                  ]
                })],
              }),
              new TableCell({
                margins: nutMargins,
                children: [new Paragraph({
                  alignment: AlignmentType.RIGHT,
                  children: [
                    new TextRun({
                      text: `${recipe.energy_kj || '     '}`,
                      bold: true,
                    }),
                  ]
                })],
              }),
              new TableCell({
                margins: nutMargins,
                children: [new Paragraph({
                  alignment: AlignmentType.RIGHT,
                  children: [
                    new TextRun({
                      text: `${Math.floor(10 * (recipe.energy_kj || 0) * portionMultiplier) / 10}`,
                      bold: true,
                    }),
                  ]
                })],
              }),
            ],
          }),
          new TableRow({
            children: [
              new TableCell({
                margins: nutMargins,
                children: [new Paragraph({
                  children: [
                    new TextRun({
                      text: "Energy kcal",
                      bold: true,
                    }),
                  ]
                })],
              }),
              new TableCell({
                margins: nutMargins,
                children: [new Paragraph({
                  alignment: AlignmentType.RIGHT,
                  children: [
                    new TextRun({
                      text: `${recipe.energy_kcal || '     '}`,
                      bold: true,
                    }),
                  ]
                })],
              }),
              new TableCell({
                margins: nutMargins,
                children: [new Paragraph({
                  alignment: AlignmentType.RIGHT,
                  children: [
                    new TextRun({
                      text: `${Math.floor(10 * (recipe.energy_kcal || 0) * portionMultiplier) / 10}`,
                      bold: true,
                    }),
                  ]
                })],
              }),
            ],
          }),
          new TableRow({
            children: [
              new TableCell({
                margins: nutMargins,
                children: [new Paragraph({
                  children: [
                    new TextRun({
                      text: "Fat",
                      bold: true,
                    }),
                  ]
                })],
              }),
              new TableCell({
                margins: nutMargins,
                children: [new Paragraph({
                  alignment: AlignmentType.RIGHT,
                  children: [
                    new TextRun({
                      text: `${recipe.fat || '     '}g`,
                      bold: true,
                    }),
                  ]
                })],
              }),
              new TableCell({
                margins: nutMargins,
                children: [new Paragraph({
                  alignment: AlignmentType.RIGHT,
                  children: [
                    new TextRun({
                      text: `${Math.floor(10 * (recipe.fat || 0) * portionMultiplier) / 10}g`,
                      bold: true,
                    }),
                  ]
                })],
              }),
            ],
          }),
          new TableRow({
            children: [
              new TableCell({
                margins: nutMargins,
                children: [new Paragraph({
                  children: [
                    new TextRun({
                      text: "- of which saturates",
                      bold: false,
                    }),
                  ]
                })],
              }),
              new TableCell({
                margins: nutMargins,
                children: [new Paragraph({
                  alignment: AlignmentType.RIGHT,
                  children: [
                    new TextRun({
                      text: `${recipe.saturates || '     '}g`,
                      bold: true,
                    }),
                  ]
                })],
              }),
              new TableCell({
                margins: nutMargins,
                children: [new Paragraph({
                  alignment: AlignmentType.RIGHT,
                  children: [
                    new TextRun({
                      text: `${Math.floor(10 * (recipe.saturates || 0) * portionMultiplier) / 10}g`,
                      bold: true,
                    }),
                  ]
                })],
              }),
            ],
          }),
          new TableRow({
            children: [
              new TableCell({
                margins: nutMargins,
                children: [new Paragraph({
                  children: [
                    new TextRun({
                      text: "Carbohydrate",
                      bold: true,
                    }),
                  ]
                })],
              }),
              new TableCell({
                margins: nutMargins,
                children: [new Paragraph({
                  alignment: AlignmentType.RIGHT,
                  children: [
                    new TextRun({
                      text: `${recipe.carbs || '     '}g`,
                      bold: true,
                    }),
                  ]
                })],
              }),
              new TableCell({
                margins: nutMargins,
                children: [new Paragraph({
                  alignment: AlignmentType.RIGHT,
                  children: [
                    new TextRun({
                      text: `${Math.floor(10 * (recipe.carbs || 0) * portionMultiplier) / 10}g`,
                      bold: true,
                    }),
                  ]
                })],
              }),
            ],
          }),
          new TableRow({
            children: [
              new TableCell({
                margins: nutMargins,
                children: [new Paragraph({
                  children: [
                    new TextRun({
                      text: "- of which sugars",
                      bold: false,
                    }),
                  ]
                })],
              }),
              new TableCell({
                margins: nutMargins,
                children: [new Paragraph({
                  alignment: AlignmentType.RIGHT,
                  children: [
                    new TextRun({
                      text: `${recipe.sugars || '     '}g`,
                      bold: true,
                    }),
                  ]
                })],
              }),
              new TableCell({
                margins: nutMargins,
                children: [new Paragraph({
                  alignment: AlignmentType.RIGHT,
                  children: [
                    new TextRun({
                      text: `${Math.floor(10 * (recipe.sugars || 0) * portionMultiplier) / 10}g`,
                      bold: true,
                    }),
                  ]
                })],
              }),
            ],
          }),
          new TableRow({
            children: [
              new TableCell({
                margins: nutMargins,
                children: [new Paragraph({
                  children: [
                    new TextRun({
                      text: "Protein",
                      bold: true,
                    }),
                  ]
                })],
              }),
              new TableCell({
                margins: nutMargins,
                children: [new Paragraph({
                  alignment: AlignmentType.RIGHT,
                  children: [
                    new TextRun({
                      text: `${recipe.protein || '     '}g`,
                      bold: true,
                    }),
                  ]
                })],
              }),
              new TableCell({
                margins: nutMargins,
                children: [new Paragraph({
                  alignment: AlignmentType.RIGHT,
                  children: [
                    new TextRun({
                      text: `${Math.floor(10 * (recipe.protein || 0) * portionMultiplier) / 10}g`,
                      bold: true,
                    }),
                  ]
                })],
              }),
            ],
          }),
          new TableRow({
            children: [
              new TableCell({
                margins: nutMargins,
                children: [new Paragraph({
                  children: [
                    new TextRun({
                      text: "Salt",
                      bold: true,
                    }),
                  ]
                })],
              }),
              new TableCell({
                margins: nutMargins,
                children: [new Paragraph({
                  alignment: AlignmentType.RIGHT,
                  children: [
                    new TextRun({
                      text: `${recipe.salt || '     '}g`,
                      bold: true,
                    }),
                  ]
                })],
              }),
              new TableCell({
                margins: nutMargins,
                children: [new Paragraph({
                  alignment: AlignmentType.RIGHT,
                  children: [
                    new TextRun({
                      text: `${Math.floor(10 * (recipe.salt || 0) * portionMultiplier) / 10}g`,
                      bold: true,
                    }),
                  ]
                })],
              }),
            ],
          }),
      ]
    })
    
    const tableRows = [
      new TableRow({
              children: [
                  new TableCell({
                      margins,
                      verticalAlign: VerticalAlign.CENTER,
                      children: [new Paragraph("Product description:")],
                      width: {
                        size: convertMillimetersToTwip(50),
                        type: WidthType.DXA,
                      },
                  }),
                  new TableCell({
                      margins,
                      verticalAlign: VerticalAlign.CENTER,
                      children: [new Paragraph({
                        children: [
                          new TextRun({
                            text: (recipe.label_name || recipe.display_name || recipe.name).trim(),
                            size: 40,
                            bold: true,
                          }),
                        ]
                      })],
                      width: {
                        size: convertMillimetersToTwip(140),
                        type: WidthType.DXA,
                      },
                  }),
              ],
          }),
          new TableRow({
              children: [
                  new TableCell({
                    margins,
                    children: [new Paragraph("Unique product code:")],
                  }),
                  new TableCell({
                    margins,
                    children: [new Paragraph({
                      children: [
                        new TextRun({
                          text: `${fullRecipeType(recipe.type)} ${PID}`,
                          bold: true,
                        }),
                      ]
                    })],
                }),
              ],
          }),
          new TableRow({
              children: [
                  new TableCell({
                    margins,
                    children: [new Paragraph("Ingredients:")],
                  }),
                  new TableCell({
                    margins,
                      children: [new Paragraph({
                        children: formattedIngredients
                      })],
                  }),
              ],
          }),
          new TableRow({
              children: [
                  new TableCell({
                    margins,
                    children: [new Paragraph("Allergens:")],
                  }),
                  new TableCell({
                    margins,
                    children: [new Paragraph({
                      children: [
                        new TextRun({
                          text: allergenList,
                          bold: true,
                        }),
                      ]
                    })],
                  }),
              ],
          }),
          new TableRow({
              children: [
                  new TableCell({
                    margins,
                    children: [new Paragraph("Product claims:")],
                  }),
                  new TableCell({
                    margins,
                    children: [new Paragraph({
                      children: [
                        new TextRun({
                          text: recipe.claims || "",
                          bold: true,
                        }),
                      ]
                    })],
                  }),
              ],
          }),
          new TableRow({
              children: [
                  new TableCell({
                    margins,
                    children: [new Paragraph("Portions:")],
                  }),
                  new TableCell({
                    margins,
                    children: [new Paragraph({
                      children: [
                        new TextRun({
                          text: `${recipe.portions || ""}`,
                          bold: true,
                        }),
                      ]
                    })],
                  }),
              ],
          }),
          new TableRow({
              children: [
                  new TableCell({
                    margins,
                    children: [new Paragraph("Product dimensions:")],
                  }),
                  new TableCell({
                    margins,
                    children: [new Paragraph({
                      children: [
                        new TextRun({
                          text: `Width: ${recipe.product_width || '          '} cm          Height: ${recipe.product_height || '          '} cm          Depth: ${recipe.product_depth || '          '} cm`,
                          bold: true,
                        }),
                      ]
                    })],
                  }),
              ],
          }),
          new TableRow({
              children: [
                  new TableCell({
                    margins,
                    children: [new Paragraph("Topping decorations:")],
                  }),
                  new TableCell({
                    margins,
                    children: [new Paragraph({
                      children: [
                        new TextRun({
                          text: recipe.topping || "",
                          bold: true,
                        }),
                      ]
                    })],
                  }),
              ],
          }),
          new TableRow({
              children: [
                  new TableCell({
                    margins,
                    children: [new Paragraph("Fruit toppings:")],
                  }),
                  new TableCell({
                    margins,
                    children: [new Paragraph({
                      children: [
                        new TextRun({
                          text: recipe.fruit_topping || "",
                          bold: true,
                        }),
                      ]
                    })],
                  }),
              ],
          }),
          new TableRow({
              children: [
                  new TableCell({
                    margins,
                    children: [new Paragraph("Storage:")],
                  }),
                  new TableCell({
                    margins,
                    children: [new Paragraph({
                      children: [
                        new TextRun({
                          text: recipe.storage || "",
                          bold: true,
                        }),
                      ]
                    })],
                  }),
              ],
          }),
          new TableRow({
              children: [
                  new TableCell({
                    margins,
                    children: [new Paragraph("Shelf life:")],
                  }),
                  new TableCell({
                    margins,
                    children: [new Paragraph({
                      children: [
                        new TextRun({
                          text: recipe.shelf_life || "",
                          bold: true,
                        }),
                      ]
                    })],
                  }),
              ],
          }),
          new TableRow({
              children: [
                  new TableCell({
                    margins,
                    children: [new Paragraph("Instructions for use:")],
                  }),
                  new TableCell({
                    margins,
                    children: [new Paragraph({
                      children: [
                        new TextRun({
                          text: recipe.instructions || "",
                          bold: true,
                        }),
                      ]
                    })],
                  }),
              ],
          }),
          new TableRow({
              children: [
                  new TableCell({
                    margins,
                    children: [new Paragraph("Packaging:")],
                  }),
                  new TableCell({
                    margins,
                    children: [new Paragraph({
                      children: [
                        new TextRun({
                          text: recipe.packaging || "",
                          bold: true,
                        }),
                      ]
                    })],
                  }),
              ],
          }),
          new TableRow({
              children: [
                  new TableCell({
                    margins,
                    children: [new Paragraph("Packaging dimensions:")],
                  }),
                  new TableCell({
                    margins,
                    children: [new Paragraph({
                      children: [
                        new TextRun({
                          text: `Width: ${recipe.packaging_width || '          '} cm          Height: ${recipe.packaging_height || '          '} cm          Depth: ${recipe.packaging_depth || '          '} cm`,
                          bold: true,
                        }),
                      ]
                    })],
                  }),
              ],
          }),
          new TableRow({
              children: [
                  new TableCell({
                    margins,
                    children: [new Paragraph("Weight:")],
                  }),
                  new TableCell({
                    margins,
                    children: [new Paragraph({
                      children: [
                        new TextRun({
                          text: `Net: ${recipe.net_weight || '          '} g          Gross: ${recipe.gross_weight || '          '} g`,
                          bold: true,
                        }),
                      ]
                    })],
                  }),
              ],
          }),
          new TableRow({
              children: [
                  new TableCell({
                    margins,
                    children: [new Paragraph("Nutrition:")],
                  }),
                  new TableCell({
                    margins,
                    children: [nutrition],
                  }),
              ],
          }),
    ]


    if (imageResponse.ok) {
      tableRows.push(
        new TableRow({
          children: [
              new TableCell({
                margins,
                children: [new Paragraph("Photo:")],
              }),
              new TableCell({
                margins,
                children: [new Paragraph({
                  children: [
                    new ImageRun({
                      type: 'jpg',
                      data: imageBuffer,    
                      transformation: {
                        width: 400,
                        height: 400,
                      },          
                    })
                  ]
                })],
              }),
          ],
        }),
      )

    }

    const table = new Table({
      layout: TableLayoutType.FIXED,
      width: {
          size: convertMillimetersToTwip(190),
          type: WidthType.DXA,
      },
      borders: {
        top: { style: BorderStyle.NIL },
        bottom: { style: BorderStyle.NIL },
        left: { style: BorderStyle.NIL },
        right: { style: BorderStyle.NIL },
        insideHorizontal: { style: BorderStyle.NIL },
        insideVertical: { style: BorderStyle.NIL },
      },
      rows: tableRows,
    });

    

    
    const doc = new Document({
      styles: {
        default: {
          document: {
            run: {
              font: "Arial",
              size: 24, // 12pt
            },
            paragraph: {
              spacing: {
                after: 120,
              },
            },
          },
        },
      },
      sections: [
        {
          headers: {
            default: new Header({
              children: [
                new Paragraph({
                  text: "EL&N SPEC CARDS & LOOKBOOK",
                  alignment: AlignmentType.CENTER,
                  heading: HeadingLevel.HEADING_1,
                }),
                new Paragraph(""),
             ],
            }),
          },
          properties: {
                page: {
                    size: {
                        orientation: PageOrientation.PORTRAIT,
                        width: convertMillimetersToTwip(210),
                        height: convertMillimetersToTwip(297),
                    },
                    margin: {
                        top: convertMillimetersToTwip(10), 
                        right: convertMillimetersToTwip(10),
                        bottom: convertMillimetersToTwip(10),
                        left: convertMillimetersToTwip(10),
                    },
                },
            },
          children: [table],
          footers: {
            default: new Footer({
              children: [
                new Paragraph({
                      children: [
                        new TextRun({
                          text: "Processed in a factory that contains other allergens: ",
                          bold: false,
                        }),
                        new TextRun({
                          text: "NUTS, SULPHITES, SOYA, WHEAT",
                          bold: true,
                        }),
                      ],      
                    alignment: AlignmentType.CENTER,
                }),
                
                new Paragraph({
                    text: `${businessData.invoiceHeaderName}, ${businessData.address}`,
                    alignment: AlignmentType.CENTER,
                    heading: HeadingLevel.HEADING_4,
                }),
              ],
            }),
          }
        }
      ],
    });

    const blob = await Packer.toBlob(doc);
    saveAs(blob, `lookbook-${cleanPID(recipe.pid, recipe.type)}.docx`);
  };

  return <button className={recipe.type === 'D' ? 'inv' : ''} disabled={recipe.type !== 'D'} onClick={handleDownload}><FontAwesomeIcon icon={faBook} />  Lookbook</button>;
}

